import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
// import '../css/UpdateUserProfile.css'; 
import axios from 'axios';
import CustomHeader from '../components/Header'
import { Navbar, Nav, Container, Button, Dropdown, Row, Col, CardGroup, CardDeck, Card } from 'react-bootstrap';

import Stepper from 'react-stepper-horizontal';

import Select from 'react-select'

const headers = {
    'Content-Type': 'application/json',
    'APIkey': 'C5BFF7F0-B4DF-475E-A331-F737424F013C',
}


const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: '#7367f0'

    })
}

class AddNewUser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            middleName: '',
            lastName: '',
            email: '',
            mobileNo: '',

            steps: [
                {
                    title: 'Step One',
                    onClick: (e) => {
                        e.preventDefault()
                        console.log('onClick', 1)
                    }
                },
                {
                    title: 'Step Two',
                    onClick: (e) => {
                        e.preventDefault()
                        console.log('onClick', 2)
                    }
                }
            ],
            currentStep: 0
        }

        this.onClickNext = this.onClickNext.bind(this);
        this.onClickPrevious = this.onClickPrevious.bind(this)


        // this.changeHandler = this.changeHandler.bind(this);
        // this.submitHandler = this.submitHandler.bind(this);



    }

    onClickNext() {
        console.log(this.state.currentStep)
        if (this.state.currentStep < 2)
            this.setState({
                currentStep: this.state.currentStep + 1,
            });
    }

    onClickPrevious() {
        console.log(this.state.currentStep)
        if (this.state.currentStep > 0)
            this.setState({
                currentStep: this.state.currentStep - 1,
            });
    }


    render() {

        const { firstName, middleName, lastName, email, mobileNo } = this.state;


        const { steps, currentStep } = this.state;

        return (
            <>

                <CustomHeader>

                </CustomHeader>



                <Row>
                    <div className="col-md-12 col-12">
                        <Card>

                            <Card.Body>

                                <CardDeck className="text-left">
                                    <Card>
                                        <Card.Title className="px-3 mt-3">
                                            Add New User
                            </Card.Title>
                                        <Card.Body>

                                            <Stepper
                                                steps={steps}
                                                activeStep={currentStep}
                                                activeColor="#ffd500"
                                                defaultBarColor="#ffd500"
                                                completeColor="#404040"
                                                // completeColor="red"
                                                completeBarColor="#ffd500"
                                                defaultBorderColor="green"
                                            />


                                            {currentStep === 0 && (



                                                <div>
                                                    <div className="mb-4"><h5>User Detail</h5></div>
                                                    <Row className="m-0">
                                                        <div className="col-md-6 col-12 pl-0">
                                                            <div className="form-label-group">
                                                                <input type="text" id="email" name="email" className="form-control" value={this.state.email} onChange={this.changeHandler} />
                                                                <label htmlFor="city-column">First Name</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 col-12 pl-0">
                                                            <div className="form-label-group">
                                                                <input type="text" id="email" name="email" className="form-control" value={this.state.email} onChange={this.changeHandler} />
                                                                <label htmlFor="city-column">Last Name</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 col-12 pl-0">
                                                            <div className="form-label-group">
                                                                <input type="text" id="email" name="email" className="form-control" value={this.state.email} onChange={this.changeHandler} />
                                                                <label htmlFor="city-column">Email</label>
                                                            </div>
                                                        </div>
                                                    </Row>

                                                </div>



                                            )}

                                            {currentStep === 1 && (

                                                <>
                                                    <h5>Permission</h5>
                                                    <div>Choose which sections of the Shell Telematics Portal the New User can view and edit.</div>
                                                    <br />
                                                    <CardDeck>
                                                            <Card>
                                                            <Card.Body className="p-0">
                                                                <div className="border border-secondary rounded p-3">

                                                                  <div className="mb-3"><strong>Manage Shell Cards & Devices </strong></div> 
                                                                    <div>
                                                                       
                                                                        <div class="custom-control custom-switch custom-control-inline">
                                                                            <input type="checkbox" class="custom-control-input" id="customSwitch1"  onChange={this.LocationChange}/>
                                                                                <label class="custom-control-label" for="customSwitch1">
                                                                                </label>
                                                                                <span class="switch-label">Read Only</span>
                                                                            </div>
                                                                        
                                                                       
                                                                        <div class="custom-control custom-switch custom-control-inline">
                                                                            <input type="checkbox" class="custom-control-input" id="customSwitch2"  onChange={this.LocationChange}/>
                                                                                <label class="custom-control-label" for="customSwitch2">
                                                                                </label>
                                                                                <span class="switch-label">Read & Edit</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="text-success">
                                                                            <small>
                                                                                Acceptable Events : {this.state.valueLocation}
                                                                            </small>
                                                                        </div>
                                                                    </div>

                                                            </Card.Body>
                                                        </Card>
                                                            <Card>
                                                                <Card.Body className="p-0">
                                                                    <div className="border border-secondary rounded p-3">
                                                                    <div className="mb-3"><strong>Manage Device Groups </strong></div>
                                                                        {/* <label className="switch">
                                                                            <input type="checkbox" className="warning" onChange={this.OverCapacityChange} />
                                                                            <span className="slider round" />
                                                                        </label> */}
                                                                        <div>
                                                                       
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch3"  onChange={this.OverCapacityChange}/>
                                                                               <label class="custom-control-label" for="customSwitch3">
                                                                               </label>
                                                                               <span class="switch-label">Read Only</span>
                                                                           </div>
                                                                       
                                                                      
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch4"  onChange={this.OverCapacityChange}/>
                                                                               <label class="custom-control-label" for="customSwitch4">
                                                                               </label>
                                                                               <span class="switch-label">Read & Edit</span>
                                                                           </div>
                                                                       </div>
                                                                        <div className="text-success ">
                                                                            <small>
                                                                                Acceptable [Variance, Events] : {this.state.valueOverCapacity}
                                                                            </small>
                                                                        </div>
                                                                    </div>

                                                                </Card.Body>
                                                            </Card>
                                                            <Card>
                                                                <Card.Body className="p-0">
                                                                    <div className="border border-secondary rounded p-3">
                                                                    <div className="mb-3"> <strong>Manage Suspicious Transactions</strong></div>
                                                                    <div>
                                                                       
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch5"  onChange={this.OverCapacityChange}/>
                                                                               <label class="custom-control-label" for="customSwitch5">
                                                                               </label>
                                                                               <span class="switch-label">Read Only</span>
                                                                           </div>
                                                                       
                                                                      
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch6"  onChange={this.OverCapacityChange}/>
                                                                               <label class="custom-control-label" for="customSwitch6">
                                                                               </label>
                                                                               <span class="switch-label">Read & Edit</span>
                                                                           </div>
                                                                       </div>
                                                                        <div className="text-success ">
                                                                            <small>
                                                                                Acceptable Events : {this.state.valueQuantity}
                                                                            </small>
                                                                        </div>
                                                                    </div>

                                                                </Card.Body>
                                                            </Card>
                                                    </CardDeck>
                                                        <CardDeck>
                                                            <Card>
                                                                <Card.Body className="p-0">
                                                                    <div className="border border-secondary rounded p-3">
                                                                    <div className="mb-3"> <strong>Manage HSSE</strong></div>
                                                                        
                                                                        <div>
                                                                       
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch7" onChange={this.CardMileageChange}/>
                                                                               <label class="custom-control-label" for="customSwitch7">
                                                                               </label>
                                                                               <span class="switch-label">Read Only</span>
                                                                           </div>
                                                                       
                                                                      
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch7" onChange={this.CardMileageChange}/>
                                                                               <label class="custom-control-label" for="customSwitch7">
                                                                               </label>
                                                                               <span class="switch-label">Read & Edit</span>
                                                                           </div>
                                                                       </div>
                                                                        <div className="text-success ">
                                                                            <small>
                                                                                Acceptable [Variance, Events] : {this.state.valueMileage}
                                                                            </small>
                                                                        </div>
                                                                    </div>

                                                                </Card.Body>
                                                            </Card>
                                                            <Card>
                                                                <Card.Body className="p-0">
                                                                    <div className="border border-secondary rounded p-3">
                                                                    <div className="mb-3"><strong>Manage Vehicle Health & Maintenance</strong></div>
                                                                        
                                                                        <div>
                                                                       
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch8" onChange={this.RunningMileageChange}/>
                                                                               <label class="custom-control-label" for="customSwitch8">
                                                                               </label>
                                                                               <span class="switch-label">Read Only</span>
                                                                           </div>
                                                                       
                                                                      
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch9" onChange={this.RunningMileageChange}/>
                                                                               <label class="custom-control-label" for="customSwitch9">
                                                                               </label>
                                                                               <span class="switch-label">Read & Edit</span>
                                                                           </div>
                                                                       </div>
                                                                        <div className="text-success ">
                                                                            <small>
                                                                                Acceptable [Variance, Events] : {this.state.valueRunning}
                                                                            </small>
                                                                        </div>
                                                                    </div>

                                                                </Card.Body>
                                                            </Card>
                                                            <Card>
                                                            <Card.Body className="p-0">
                                                                    <div className="border border-secondary rounded p-3">
                                                                    <div className="mb-3"><strong>Manage Declined Transactions </strong></div>
                                                                        
                                                                        <div>
                                                                       
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch10" onChange={this.ProductMismatchChange}/>
                                                                               <label class="custom-control-label" for="customSwitch10">
                                                                               </label>
                                                                               <span class="switch-label">Read Only</span>
                                                                           </div>
                                                                       
                                                                      
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch11" onChange={this.ProductMismatchChange}/>
                                                                               <label class="custom-control-label" for="customSwitch11">
                                                                               </label>
                                                                               <span class="switch-label">Read & Edit</span>
                                                                           </div>
                                                                       </div>
                                                                        <div className="text-success ">
                                                                            <small>
                                                                                Acceptable Events : {this.state.valueProduct}
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </Card.Body>
                                                            </Card>
                                                        </CardDeck>
                                                        <br></br>
                                                        <hr></hr>
                                                        <br></br>
                                                        <h6 className="mb-3">Choose which sections of the Shell Telematics Portal the New User can view</h6>
                                                
                                                        <CardDeck>
                                                            <Card>
                                                                <Card.Body className="p-0">
                                                                    <div className="border border-secondary rounded p-3">
                                                                    <div className="mb-3"> <strong>Administration</strong></div>
                                                                        
                                                                        <div>
                                                                       
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch12"/>
                                                                               <label class="custom-control-label" for="customSwitch12">
                                                                               </label>
                                                                               <span class="switch-label">Read Only</span>
                                                                           </div>
                                                                       
                                                                      
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch13"/>
                                                                               <label class="custom-control-label" for="customSwitch13">
                                                                               </label>
                                                                               <span class="switch-label">Read & Edit</span>
                                                                           </div>
                                                                       </div>
                                                                        
                                                                    </div>

                                                                </Card.Body>
                                                            </Card>
                                                            <Card>
                                                                <Card.Body className="p-0">
                                                                    <div className="border border-secondary rounded p-3">
                                                                    <div className="mb-3"><strong>Finance</strong></div>
                                                                        
                                                                        <div>
                                                                       
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch14" onChange={this.RunningMileageChange}/>
                                                                               <label class="custom-control-label" for="customSwitch14">
                                                                               </label>
                                                                               <span class="switch-label">Read Only</span>
                                                                           </div>
                                                                       
                                                                      
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch15" onChange={this.RunningMileageChange}/>
                                                                               <label class="custom-control-label" for="customSwitch15">
                                                                               </label>
                                                                               <span class="switch-label">Read & Edit</span>
                                                                           </div>
                                                                       </div>
                                                                        
                                                                    </div>

                                                                </Card.Body>
                                                            </Card>
                                                            <Card>
                                                            <Card.Body className="p-0">
                                                                    <div className="border border-secondary rounded p-3">
                                                                    <div className="mb-3"><strong>Analytics  </strong></div>
                                                                        
                                                                        <div>
                                                                       
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch16" onChange={this.ProductMismatchChange}/>
                                                                               <label class="custom-control-label" for="customSwitch16">
                                                                               </label>
                                                                               <span class="switch-label">Read Only</span>
                                                                           </div>
                                                                       
                                                                      
                                                                       <div class="custom-control custom-switch custom-control-inline">
                                                                           <input type="checkbox" class="custom-control-input" id="customSwitch17" onChange={this.ProductMismatchChange}/>
                                                                               <label class="custom-control-label" for="customSwitch17">
                                                                               </label>
                                                                               <span class="switch-label">Read & Edit</span>
                                                                           </div>
                                                                       </div>
                                                                        
                                                                    </div>
                                                                </Card.Body>
                                                            </Card>
                                                        </CardDeck>
                                                <br></br>
                                                
                                                </>


                                            )}




                                            <div >
                                                        <div class="pull-left"><Button className="btn-shell" variant="warning" onClick={this.onClickPrevious}>Previous</Button></div>
                                                        <div class="pull-right"><Button className="btn-shell" variant="warning" onClick={this.onClickNext}>Next</Button></div>
                                                    </div>




                                                </Card.Body>
                                    </Card>
                                </CardDeck >


                            </Card.Body>
                        </Card>
                    </div>
                </Row>
            </>

        );
    }
}

export default AddNewUser;









